import React, { useState } from "react";
import "./Whatsapp.css";
import whatsImg from "../../assets/imgs/icons/whatsapp.svg";
import tCrossImg from "../../assets/imgs/icons/tCross.svg";

function Whatsapp() {
  const [isOpen, setIsOpen] = useState(false);

  const whatsappLink = "https://wa.me/9811137560";

  const openWhatsapp = () => {
    window.open(whatsappLink, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="floWhatsp">
      {isOpen && (
        <div className="hdWrp">
       
          <h6 onClick={openWhatsapp} style={{ cursor: "pointer" }}>
            Chat on WhatsApp
          </h6>

          <span className="close" onClick={() => setIsOpen(false)}>
            <img src={tCrossImg} alt="close" />
          </span>
        </div>
      )}

      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsOpen(true)}
      >
        <div className="whImWrp">
          <img src={whatsImg} alt="whatsImg" />
        </div>
      </a>
    </div>
  );
}

export default Whatsapp;
